import { render, staticRenderFns } from "./add-semis.vue?vue&type=template&id=1576645f&"
import script from "./add-semis.vue?vue&type=script&lang=js&"
export * from "./add-semis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports